"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.to-string.js");
/**
 * 获取需要格式化的字段的字典数据
 */
var _default = exports.default = {
  methods: {
    /** 根据数据字典和数据值，获取标签值
     * 使用示例： formatter:(row,column,cellValue)=> this.getRowDict("effective_status",cellValue)
     * @description: 删除 行数据
     * @param { String } dictType 数据字典编码
     * @param { Object } cellValue 数据值
     * @return { String }
     */
    getRowDict: function getRowDict(dictType, cellValue) {
      if (cellValue) {
        var list = this.$$getDict(dictType).filter(function (item) {
          return item.dictValue === cellValue.toString();
        });
        return list.length > 0 ? list[0].dictLabel : cellValue;
      }
      return '';
    }
  }
};